import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { PartnershipHeroComponent } from './components/partnership-hero/partnership-hero.component';
import { PartnershipListingComponent } from './components/partnership-listing/partnership-listing.component';
import { PartnershipInfoComponent } from './components/partnership-info/partnership-info.component';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationService } from 'app/services/application.service';
import { PartnershipDialogComponent } from '../partnership-dialog/partnership-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-partnership',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        HeaderComponent,
        FooterComponent,
        PartnershipHeroComponent,
        PartnershipListingComponent,
        PartnershipInfoComponent,
    ],
    templateUrl: './partnership.component.html',
})
export class PartnershipComponent implements OnInit {
    selectedLanguage: any;
    partnershipData: any = [];
    partnershipDataBM: any = [];
    partnershipDataEN: any = [];

    constructor(
        private applicationService: ApplicationService,
        private dialog: MatDialog,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.getPartnershipData();
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
        if (this.selectedLanguage == 'bm' && this.partnershipData.length) {
            this.partnershipData = this.partnershipDataBM;
        } else if (
            this.selectedLanguage == 'en' &&
            this.partnershipData.length
        ) {
            this.partnershipData = this.partnershipDataEN;
        }
    }

    getPartnershipData() {
        this.applicationService.getPartnership().subscribe({
            next: (data) => {
                // Get today's date
                const today = new Date();
                let filteredData = data.filter((item) => {
                    const pStartDate = new Date(item.pStartDate);
                    const pEndDate = new Date(item.pEndDate);
                    return (
                        item.status === 'ACTIVE' &&
                        pStartDate <= today && // pStartDate is same or before today's date
                        pEndDate >= today // pEndDate is same or after today's date
                    );
                });

                const listingPartnershipData = filteredData;
                this.partnershipDataBM = [];
                this.partnershipDataEN = [];
                listingPartnershipData.forEach((el: any) => {
                    let newObj = {};
                    if (
                        el?.partnershipDetails &&
                        el?.partnershipDetails?.length
                    ) {
                        if (
                            el?.partnershipDetails[0]?.languages == 'BM' ||
                            el?.partnershipDetails[1]?.languages == 'BM'
                        ) {
                            newObj = { ...el };
                            newObj['partnershipDetails'] =
                                el?.partnershipDetails[0]?.languages == 'BM'
                                    ? el?.partnershipDetails[0]
                                    : el?.partnershipDetails[1];
                            this.partnershipDataBM.push(newObj);
                        }
                        if (
                            el?.partnershipDetails[0]?.languages == 'EN' ||
                            el?.partnershipDetails[1]?.languages == 'EN'
                        ) {
                            newObj = { ...el };
                            newObj['partnershipDetails'] =
                                el?.partnershipDetails[0]?.languages == 'EN'
                                    ? el?.partnershipDetails[0]
                                    : el?.partnershipDetails[1];
                            this.partnershipDataEN.push(newObj);
                        }
                    }
                });
                this.partnershipData =
                    this.selectedLanguage == 'bm'
                        ? this.partnershipDataBM
                        : this.partnershipDataEN;
                // this.partnershipImgUrl = this.partnershipData[0]?.partnershipDetails
                //         ?.partnershipImageUrl
            },
            error: (err) => {},
        });
    }

    openPartnershipDialog(id: any) {
        this.applicationService.getPartnershipDetailsById(id).subscribe({
            next: (data) => {
                let partnershipDialogData = {};
                let newObj = {};
                if (
                    data?.partnershipDetails &&
                    data?.partnershipDetails?.length
                ) {
                    if (this.selectedLanguage == 'bm') {
                        if (
                            data?.partnershipDetails[0]?.languages == 'BM' ||
                            data?.partnershipDetails[1]?.languages == 'BM'
                        ) {
                            newObj = { ...data };
                            newObj['partnershipDetails'] =
                                data?.partnershipDetails[0]?.languages == 'BM'
                                    ? data?.partnershipDetails[0]
                                    : data?.partnershipDetails[1];
                        }
                    } else {
                        if (
                            data?.partnershipDetails[0]?.languages == 'EN' ||
                            data?.partnershipDetails[1]?.languages == 'EN'
                        ) {
                            newObj = { ...data };
                            newObj['partnershipDetails'] =
                                data?.partnershipDetails[0]?.languages == 'EN'
                                    ? data?.partnershipDetails[0]
                                    : data?.partnershipDetails[1];
                        }
                    }
                    partnershipDialogData = newObj;
                }

                this.dialog.open(PartnershipDialogComponent, {
                    width: '869px',
                    disableClose: true,
                    data: {
                        partnership: partnershipDialogData,
                        source: 'partnership',
                    },
                });
            },
            error: (err) => {
                this.toastr.error(err.error.message);
            },
        });
    }
}
